import React from 'react'
import moment from 'moment';
const ModuleDisplayDate = ({ value }) => {
    return (
        <>{(value) ? (moment(value).format("DD MMMM YYYY")) : null}</>
    )
}

export default ModuleDisplayDate